export const checkIsEtsGlobal = (businessName) => {
  const regex = new RegExp('ets global', 'i');

  return regex.test(businessName);
};
